var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17749 13.0435C1.82861 13.0415 1.4841 12.9674 1.16651 12.8261C0.823032 12.678 0.53039 12.4363 0.323538 12.1299C0.116687 11.8234 0.00436949 11.4652 0 11.098V1.94673C0.00436949 1.57954 0.116687 1.22133 0.323538 0.914897C0.53039 0.608464 0.823032 0.366755 1.16651 0.218639C1.56173 0.036013 2.00144 -0.034327 2.43553 0.0156343C2.86963 0.0655956 3.28065 0.233849 3.62175 0.501221L9.28767 5.07686C9.50986 5.24991 9.68929 5.46974 9.81262 5.72001C9.93595 5.97028 10 6.24454 10 6.52237C10 6.80021 9.93595 7.07446 9.81262 7.32473C9.68929 7.575 9.50986 7.79484 9.28767 7.96788L3.62175 12.5435C3.21333 12.8675 2.70332 13.0441 2.17749 13.0435Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMenu);
export default __webpack_public_path__ + "static/media/rightMenu.53f20141eba3c32cfe5233408c8ccb80.svg";
export { ForwardRef as ReactComponent };